export default "__VITE_ASSET__DNwV7OzL__"